import { Injectable } from '@angular/core';
import { CookieService } from 'angular2-cookie/core';

@Injectable()
export class Cookies {

    constructor( private cookieService:CookieService ){}
    
	public getCookie(name:string){
		return this.cookieService.getObject(name);
	}
	//'ChamUserObject'
	public setCookie(name:string,data: Object){
		return this.cookieService.putObject(name,data,true);
	}

	public removeCookie(name:string){
		this.cookieService.remove(name);
	}

}



// WEBPACK FOOTER //
// ./src/app/class/cookies.ts